"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.useModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _d3Selection = require("d3-selection");

var _d3Transition = require("d3-transition");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DefaultModalOptions = {
  duration: 750,
  hideOnAction: true
};

var useModal = function useModal() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultModalOptions;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      show = _React$useState2[0],
      setShow = _React$useState2[1];

  var openModal = _react["default"].useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault();
    setShow(true);
  }, []);

  var closeModal = _react["default"].useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault();
    setShow(false);
  }, []);

  return [_objectSpread({
    show: show,
    closeModal: closeModal
  }, options), openModal, closeModal];
};

exports.useModal = useModal;

var Modal = function Modal(_ref) {
  var show = _ref.show,
      closeModal = _ref.closeModal,
      actions = _ref.actions,
      duration = _ref.duration,
      hideOnAction = _ref.hideOnAction,
      children = _ref.children;

  var outer = /*#__PURE__*/_react["default"].createRef(),
      inner = /*#__PURE__*/_react["default"].createRef();

  var _React$useState3 = _react["default"].useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      closed = _React$useState4[0],
      setClosed = _React$useState4[1];

  _react["default"].useEffect(function () {
    if (closed && show) {
      var transition = (0, _d3Transition.transition)().duration(duration);
      (0, _d3Selection.select)(outer.current).style("background-color", "rgba(0, 0, 0, 0.0)").transition(transition).style("background-color", "rgba(0, 0, 0, 0.75)");
      (0, _d3Selection.select)(inner.current).style("top", "-50%").transition(transition).style("left", "50%").style("top", "50%");
      setClosed(!show);
    } else if (!closed && !show) {
      var _transition = (0, _d3Transition.transition)().duration(duration);

      (0, _d3Selection.select)(outer.current).transition(_transition).style("background-color", "rgba(0, 0, 0, 0.0)");
      (0, _d3Selection.select)(inner.current).transition(_transition).style("left", "50%").style("top", "-50%").end().then(function () {
        return setClosed(!show);
      });
    }
  }, [outer, inner, show, closed, setClosed, duration]);

  var theme = (0, _avlComponents.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: outer,
    className: "inset-0 z-50 cursor-auto fixed",
    style: {
      display: closed ? "none" : "block"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: inner,
    className: "absolute inline-block",
    style: {
      transform: "translate(-50%, -50%)",
      left: "50%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    onClick: closeModal,
    small: true,
    className: "\n            top-0 left-0 absolute ".concat(theme.menuBg, "\n          "),
    style: {
      transform: "translate(-50%, -50%)"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa text-lg fa-times"
  })), children));
};

exports.Modal = Modal;